/* eslint-disable import/prefer-default-export */
import { filter, path } from 'ramda';
import { createSelector } from 'reselect';
import { filterNullRecords } from "../Company/selectors";

export const selectVehicles = state => path(['api', 'vehicle', 'data'], state) || [];

export const selectActiveVehicles = createSelector(
  [selectVehicles],
  (vehicles) => {
    const filteredDeletedVehicles = filterNullRecords(vehicles, 'deleted-at')

    return filter(vehicle => path(['attributes', 'is-active'], vehicle) !== false)(filteredDeletedVehicles)
  },
);

export const selectInactiveVehicles = createSelector(
  [selectVehicles],
  (vehicles) => {
    const filteredDeletedVehicles = filterNullRecords(vehicles, 'deleted-at')

    return filter(vehicle => path(['attributes', 'is-active'], vehicle) === false)(filteredDeletedVehicles)
  },
);
